import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type FilterResetTarget = 'reconciliations' | 'batches';

@Injectable({
  providedIn: 'root'
})
export class FilterResetService {
  private resetSubject = new Subject<FilterResetTarget>();
  reset$ = this.resetSubject.asObservable();

  triggerReset(target: FilterResetTarget): void {
    this.resetSubject.next(target);
  }
}

